import _ from 'lodash'
import {connect} from 'react-redux'

import {ItineraryBottom} from './itinerarybottom.component'
import {updateTotalDays, updateDestination, appendDay} from '../planner/planner.action'
import {addLeg, addLegAndDestination, deleteLeg} from '../leg/leg.action'
import {progressInitState, regressInitState} from '../init/initialdata.action'
import {setCommitMsg} from '../socket/socket.action'

import mixpanelUtil from '../util/mixpanel.util'
import legUtil from '../util/leg.util'


const mapStateToProps = (state) => {
    var activeLeg = legUtil.getActiveLeg(state)
    var lastLeg = legUtil.getLastLeg(state)
    return {
        initStep: state.getIn(['document', 'properties', 'initStep']),
        halfHidden: !_.isUndefined(activeLeg),
        leg: activeLeg,
        originDestination: state.getIn(['document', 'properties', 'origination']),
        returnDestination: state.getIn(['document', 'properties', 'return']),
        lastLeg: lastLeg,
        totalDays: state.getIn(['document', 'properties', 'totalDays']) || 1,
        lunaTripSlug: state.getIn(['lunaTrip', 'trip', 'slug'])
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onSaveTripLength: (tripLength) => {
            mixpanelUtil.send('setTripLength', {'length': tripLength})
            dispatch(setCommitMsg('Set length of trip to ' + tripLength + ' days'))
            dispatch(updateTotalDays(tripLength))
        },
        onProgressInitState: () => {
            // this will set an initial leg, probably need to check state
            dispatch(setCommitMsg('Added new leg'))
            dispatch(addLeg(0, 1))
            dispatch(progressInitState())
        },
        onRegressInitState: () => {
            dispatch(regressInitState())
        },
        onAddLeg: (startDay, legLength) => {
            dispatch(addLeg(startDay, legLength))
        },
        onSelectDestination: (leg, destination) => {
            dispatch(updateDestination(leg, destination))
        },
        onAddLegAndDestination: (startDay, destination) => {
            // dispatch(setCommitMsg("Added new leg and set destination to "+destination.getIn()))
            dispatch(addLegAndDestination(startDay, destination))
        },
        onAppendDayAndLeg(startDay, legLength) {
            dispatch(appendDay())
            dispatch(addLeg(startDay, legLength))
        },
        onAppendDay: (startDay, destination) => {
            dispatch(appendDay())
            dispatch(addLegAndDestination(startDay, destination))
        },
        onDeleteLeg: (leg) => {
            dispatch(setCommitMsg('Delete leg'))
            dispatch(deleteLeg(leg))
        },
    }
}

const ItineraryBottomContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ItineraryBottom)

export default ItineraryBottomContainer
